const getUserProfile = (state: AnyFixMe) => state.userProfile;

export { getUserProfile };
